module.exports = __webpack_public_path__ + "media/ss_photos/ss-overview-photo-08-9dfae669.webp";